import { render, staticRenderFns } from "./ParentWallet.vue?vue&type=template&id=a086a01e&"
import script from "./ParentWallet.vue?vue&type=script&lang=js&"
export * from "./ParentWallet.vue?vue&type=script&lang=js&"
import style0 from "./ParentWallet.vue?vue&type=style&index=0&id=a086a01e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports